import React from 'react'
import { useHistory } from 'react-router-dom'
import { ArrowRight as ArrowRightIcon } from 'react-feather'
import { reverse } from 'named-urls'
import PropTypes from 'prop-types'
import moment from 'moment'
import clsx from 'clsx'
import { Chip, IconButton } from '@material-ui/core'

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'components/Table'

import helpers from 'helpers'

import { routes } from 'Routes'
import useStyles from './styles'
import constants from 'constants/index'

const getCategory = (ticket) => {
  if (ticket?.category) return ticket.category
  const answer = ticket?.info?.questionDemand?.answer
  if (answer?.options?.length) return answer.options[0].title
  return answer?.title || null
}

const TicketTable = ({ tickets = [], isLoading = false }) => {
  const { dates } = helpers.formatters

  const {
    PENDING_STATUS_ID,
    STATUS_TRANSLATION_LABELS,
    STATUS_CHIP_CLASSNAME,
  } = constants.tickets

  const classes = useStyles()
  const history = useHistory()

  const handleRedirect = (ticketId) =>
    history.push(
      reverse(routes.privacyPortal.tickets.details, {
        ticketId,
      }),
    )

  return (
    <Table
      emptyMessage="Nenhuma solicitação foi encontrada."
      isLoading={isLoading}
    >
      <TableHead>
        <TableRow>
          <TableCell width="5%">ID</TableCell>
          <TableCell width="11%">Responsável</TableCell>
          <TableCell width="15%">Solicitante</TableCell>
          <TableCell width="30%">Categoria</TableCell>
          <TableCell align="center" width="11%">
            Data de confirmação
          </TableCell>
          <TableCell align="center" width="12%">
            Prazo de atendimento
          </TableCell>
          <TableCell align="center" width="11%">
            Status
          </TableCell>
          <TableCell align="center" width="5%">
            Ações
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {tickets.map((ticket) => {
          const isOverdue =
            ticket?.companyStatus?.id === PENDING_STATUS_ID &&
            ticket?.companyDeadlineDate &&
            moment(ticket.companyDeadlineDate).isBefore(moment())

          return (
            <TableRow
              key={ticket?.id}
              pointer
              onClick={() => handleRedirect(ticket?.id)}
            >
              <TableCell>{ticket?.id}</TableCell>
              <TableCell>
                {ticket?.responsible?.name || 'Não atribuído'}
              </TableCell>
              <TableCell>
                {ticket?.userName || 'Usuário não informado'}
              </TableCell>
              <TableCell>{getCategory(ticket)}</TableCell>
              <TableCell align="center">
                {dates.ptBrFormatDateTime(ticket?.confirmedAt)}
              </TableCell>
              <TableCell align="center">
                {dates.ptBrFormatDate(ticket?.companyDeadlineDate)}
              </TableCell>
              <TableCell align="center">
                <Chip
                  label={
                    isOverdue
                      ? 'Atrasada'
                      : STATUS_TRANSLATION_LABELS[ticket?.companyStatus?.id] ||
                        ticket?.status?.name
                  }
                  size="small"
                  className={clsx(
                    classes.chip,
                    isOverdue
                      ? classes.overdue
                      : classes[
                          STATUS_CHIP_CLASSNAME[ticket?.companyStatus?.id]
                        ] || '',
                  )}
                />
              </TableCell>
              <TableCell align="center" className={classes.action}>
                <IconButton onClick={() => handleRedirect(ticket?.id)}>
                  <ArrowRightIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          )
        })}
      </TableBody>
    </Table>
  )
}

TicketTable.propTypes = {
  tickets: PropTypes.arrayOf(PropTypes.object),
  isLoading: PropTypes.bool,
}

export default TicketTable
